import {
    FETCH_BUDGET_REPORT,
} from '../../actions/types';

const INITIAL_STATE = {
    budgetReport: [],
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case FETCH_BUDGET_REPORT:
            return { ...state, budgetReport: action.payload };        
        default:
            return state;
    }
};
